import { useMemo } from 'react';
import { Group } from '../services';
import { RoleRow } from '../types/role';
import { roleTransformGroups } from '../utils/roleTransform';

interface UseRolesTableProps {
  data?: {
    results: Group[];
    count: number;
  };
}

export function useRolesTable({ data }: UseRolesTableProps) {
  const roles = useMemo<RoleRow[]>(() => {
    if (!data) return [];
    return roleTransformGroups(data.results);
  }, [data]);

  return {
    roles,
    total: data?.count ?? 0,
  };
}
